import {defineComponent, DataTable} from "../../../src";
import Theme from "./Theme";

defineComponent(DataTable.componentName, DataTable, 'example');
defineComponent(Theme.componentName, Theme, 'example');

